import { useEffect, useMemo } from 'react';
import * as R from 'remeda';
import {
  GridRenderEditCellParams,
  GridRowId,
  GridValidRowModel,
  GridValueSetter,
} from '@rossum/ui/x-data-grid-pro';

type UseHandleSelectionSyncParams = {
  apiRef: GridRenderEditCellParams['api'];
  id: GridRowId;
  field: string;
  setBatchEditError: React.Dispatch<React.SetStateAction<boolean>>;
  hasError: boolean;
};

export const useHandleSelectionSync = ({
  apiRef,
  id,
  field,
  setBatchEditError,
  hasError,
}: UseHandleSelectionSyncParams) => {
  const editCellState = apiRef.unstable_getEditCellMeta(id, field);

  const hasChanged = !!editCellState?.changeReason;
  // @ts-expect-error wrongly typed editCellState :-/
  const editValue = editCellState?.value;

  const columsMap = useMemo(
    () => R.fromEntries(apiRef.getAllColumns().map(c => [c.field, c])),
    [apiRef]
  );

  useEffect(() => {
    if (hasChanged) {
      const selectedRows = Array.from(apiRef.getSelectedRows().values());

      if (selectedRows.length !== 0) {
        const fieldColumn = columsMap[field];
        const columnValueSetter = fieldColumn?.valueSetter;
        const defaultValueSetter: GridValueSetter<GridValidRowModel> = (
          value,
          row
        ) => ({
          ...row,
          [field]: value,
        });
        const fieldValueSetter: GridValueSetter<GridValidRowModel> =
          columnValueSetter ?? defaultValueSetter;

        // TODO: there is a conflict between eslint and tsconfig.next for fieldColumn
        // after migration, we can remove the ternary operator
        const updatedRows = fieldColumn
          ? selectedRows.map(row =>
              fieldValueSetter(editValue, row, fieldColumn, {
                current: apiRef,
              })
            )
          : [];
        apiRef.updateRows(updatedRows);
        setBatchEditError(hasError);
      }
    }
  }, [
    hasChanged,
    apiRef,
    field,
    hasError,
    columsMap,
    editValue,
    setBatchEditError,
  ]);
};
